module.exports = __webpack_public_path__ + "static/media/pg27.e8fb4fe4.jpg";